import { render, staticRenderFns } from "./MarketResearchPage.vue?vue&type=template&id=2fd99c60&"
import script from "./MarketResearchPage.vue?vue&type=script&lang=js&"
export * from "./MarketResearchPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports